<template>
    <div>
        <div class="row mb-1">
            <div class="col-12">
                <div class="ob1-skeleton">
                    <div class="ob1-skeleton-white mb-1" style="height: 200px" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: "DeviceAverageRatingReviewsSkeleton",
}
</script>
